import React, { useEffect, useState } from 'react';
import API from '../Api';
import { Link } from 'react-router-dom';
import SubPageHeader from '../../components/common/SubPageHeader';

const HappinessIndexCorporate = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchCorporateData = async () => {
      try {
        const res = await API.get('get-content/Corporate/');
        setData(res.data);
      } catch (err) {
        console.error("Error loading corporate data:", err);
      }
    };
    fetchCorporateData();
  }, []);
  const defaultQuestions = [
    "Go to their work place?",
    "Are all the working hours of every member of the company filled with HAPPY CHEMICALS?",
    "How to retain skilled and trained employees in the company?",
    "How to build a healthy happy culture in the company?",
    "How to maintain a perfect Emotional Quotient (EQ) balance in the company?",
    "How to maintain cordial relationships between every employee in the company?",
    "How to GROW the company in all aspects as a family?",
    "How to build a legacy?",
    "What is the HAPPINESS INDEX of your company?"
  ];
  const questions = [1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => data[`q_${i}`]).filter(q => q);
  const displayQuestions = questions.length > 0 ? questions : defaultQuestions;

  return (
    <div className="min-h-screen bg-white">
      {/* 1. Header with correct title and straight font */}
      <SubPageHeader title="HAPPINESS INDEX CORPORATE" />

      <div className="py-10 md:py-20 px-4 md:px-6">
        <div className="max-w-5xl mx-auto border-4 md:border-[12px] border-[#003366] rounded-2xl md:rounded-[40px] shadow-2xl p-5 sm:p-8 md:p-16">
          
          <div className="space-y-6 md:space-y-10 text-[#1a1a1a] text-[15px]  md:text-[17px] leading-7   md:leading-relaxed  font-medium">
            
            {/* Introductory Statement */}
            <div className="border-l-4 md:border-l-8 border-[#54a50f] pl-4  md:pl-6 py-3 bg-gray-50 rounded-r-lg">
              <p className="text-lg sm:text-xl md:text-2xl text-[#032167] font-bold leading-relaxed">
                Does every employee of your company -right from the top management to the bottom line, are happy and excited every day to
              </p>
            </div>

            <p className="text-base md:text-lg leading-relaxed">
              The incorporation of some simple, easy-to-do tools & techniques can develop a culture of trust and bond 
              between all the employees, leading to a win-win situation for the company.
            </p>

            {/* List of Critical Corporate Questions */}
            <div className=" grid
                  grid-cols-1
                  md:grid-cols-2
                  gap-3
                  md:gap-6"
            >
              {displayQuestions.map((question, index) => (
                <div key={index} className="flex items-start p-3 md:p-4 bg-[#f8fafc] rounded-xl border border-gray-100 hover:shadow-md transition-all">
                  <span className="text-[#54a50f] font-bold mr-3">{index + 1}.</span>
                  <p className="text-sm md:text-base text-[#334155] leading-relaxed">{question}</p>
                </div>
              ))}
            </div>

            {/* Closing Statement */}
            <p className="text-base md:text-lg font-bold text-[#032167] leading-relaxed">
                 Small or big every owner -top management of the company wants to succeed.
            </p>
            <p className="text-lg font-bold text-[#032167] pt-6">
              

              The incorporation of some simple -easy to do tools & techniques can develop a culture of trust and bond between

              
              
            </p>
            <p className="text-lg font-bold text-[#032167] pt-6">
                All the employees leading to a win-win situation for the company.

            </p>
            <p className="text-lg font-bold text-[#032167] pt-6">
                Let us understand the small investments to make every second of the employees happening & happy, 
                ultimately leading to the success of the company.

            </p>
            {/* Call to Action Section */}
            <div className="mt-10 p-5 md:p-8 bg-[#003366] rounded-2xl md:rounded-[30px] text-center text-white space-y-5 max-w-2xl mx-auto">
              <p className="text-base sm:text-lg md:text-2xl font-bold uppercase tracking-wide leading-relaxed">
                To book a workshop, send a query or contact us
              </p>
              
              <div className="flex justify-center">
                <Link
                    to="/TGSH/contact"
                    className="
                        inline-flex
                        items-center
                        justify-center
                        min-w-[180px]
                        bg-[#54a50f]
                        hover:bg-[#032167]
                        text-white
                        px-6
                        py-3
                        rounded-full
                        font-bold
                        uppercase
                        whitespace-nowrap
                        shadow-lg
                        transition-all
                    "
                >
                    Contact Us
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HappinessIndexCorporate;